import { Component, OnInit } from '@angular/core';
import * as buildInfo from './../../environments/buildInfo';
import * as environment from './../../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'prefund';
  ngOnInit(): void {
    console.log(
      `Version: ${buildInfo.version}, Commit Hash: ${buildInfo.commitHash}, Build Date: ${buildInfo.buildDate}, Build Name: ${environment.environment.name}`
    );
  }
}
